import React from 'react';
import Link from 'next/link';
import {
  FacebookIcon,
  XIcon,
  InstagramIcon,
  YouTubeIcon,
  PinterestIcon,
  LinkedInIcon,
  TikTokIcon,
} from '@/componentv2/icons';
import './socialLinks.scss';

interface SocialLinksProps {
  className?: string;
}

const SocialLinks: React.FC<SocialLinksProps> = ({ className }) => {
  return (
    <div className={`social-links ${className || ''}`}>
      <Link
        href="https://www.facebook.com/SignUpGenius"
        className="social-link"
        aria-label="Facebook"
        target="_blank"
        rel="noopener noreferrer"
      >
        <FacebookIcon />
      </Link>
      <Link
        href="https://x.com/SignUpGenius"
        className="social-link"
        aria-label="X (Twitter)"
        target="_blank"
        rel="noopener noreferrer"
      >
        <XIcon />
      </Link>
      <Link
        href="https://www.instagram.com/signupgenius"
        className="social-link"
        aria-label="Instagram"
        target="_blank"
        rel="noopener noreferrer"
      >
        <InstagramIcon />
      </Link>
      <Link
        href="https://www.youtube.com/@signupgenius140"
        className="social-link"
        aria-label="YouTube"
        target="_blank"
        rel="noopener noreferrer"
      >
        <YouTubeIcon />
      </Link>
      <Link
        href="https://www.pinterest.com/signupgenius/"
        className="social-link"
        aria-label="Pinterest"
        target="_blank"
        rel="noopener noreferrer"
      >
        <PinterestIcon />
      </Link>
      <Link
        href="https://www.linkedin.com/company/signupgenius"
        className="social-link"
        aria-label="LinkedIn"
        target="_blank"
        rel="noopener noreferrer"
      >
        <LinkedInIcon />
      </Link>
      <Link
        href="https://www.tiktok.com/@signupgenius_official"
        className="social-link"
        aria-label="TikTok"
        target="_blank"
        rel="noopener noreferrer"
      >
        <TikTokIcon />
      </Link>
    </div>
  );
};

export default SocialLinks;
